module.exports = 80



// WEBPACK FOOTER //
// ./app/scripts/data/sticker-size.coffee